import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy
} from '@angular/core';
import {Project} from 'projects/app-misc/src/app/modules/project-misc/data/project/project';
import {ProjectHolder} from 'projects/app-misc/src/app/modules/project-misc/interfaces/project-holder';
import {TrelloService} from 'projects/app-misc/src/app/modules/trello-misc/data/trello.service';
import {ProjectWindowStore} from 'projects/app-misc/src/app/modules/project-misc/state/project-window.store';
import {TrelloCheckItem} from 'projects/app-misc/src/app/modules/trello-misc/data/trello-check-item';
import {User} from 'projects/core/src/lib/login/data/user';
import {HttpEventType, HttpProgressEvent, HttpResponse} from '@angular/common/http';
import {ProjectFile} from '../../data/project/project-file';
import {MatSnackBarRef, SimpleSnackBar, MatSnackBar} from '@angular/material/snack-bar';
import {Task} from 'projects/desktop/src/app/modules/home-page/data/tasks/task';
import {
  TaskEditDialogComponent
} from 'projects/desktop/src/app/modules/home-page/view/home-board/dash-board-main-block/task-column/task-edit-dialog/task-edit-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SelectItem} from 'primeng/api';
import {Subscription, timer, Observable, forkJoin} from 'rxjs';
import {Any} from 'json2typescript';
import {CheckItemHeadTag} from '../../../trello-misc/data/checkitem-head-tag';

@Component({
  selector: 'app-edit-punch-item',
  templateUrl: './edit-punch-item.component.html',
  styleUrls: ['./edit-punch-item.component.scss']
})
export class EditPunchItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input()
  checkItem: TrelloCheckItem;

  @Input()
  users: User[];

  @Input()
  tags = [];

  project: Project

  loadingSpinner = false;
  deleteLoadingSpinner = false;

  progressBar: number;

  itemDescription: string;

  @Output() closeAction = new EventEmitter<void>();
  @Output() updateAction = new EventEmitter<TrelloCheckItem>();
  @Output() deleteAction = new EventEmitter<TrelloCheckItem>();

  @ViewChild('punchItemTextArea', {static: true})
  punchItemTextArea: ElementRef;

  activeSnackBar: MatSnackBarRef<SimpleSnackBar>

  ctrlEventListener = null;
  tempKey: any;

  timerSub: Subscription;

  filePasteListener = null;

  constructor(
    protected dialog: MatDialog,
    private snackBar: MatSnackBar,
    protected projectHolder: ProjectHolder,
    protected trelloService: TrelloService,
    protected projectWindowStore: ProjectWindowStore
  ) {
    this.project = this.projectHolder.project
  }

  ngOnInit() {
    this.itemDescription = this.checkItem.name;

    this.subToCTRLEnter();


    this.filePasteListener = (event: ClipboardEvent) => {
      this.onFilePaste(event)
    }
  }

  subToCTRLEnter() {
    this.ctrlEventListener = (event: KeyboardEvent) => {
      this.ctrlEnterEvent(event)
    }

    document.addEventListener('keydown', this.ctrlEventListener);
  }

  ctrlEnterEvent(event) {
    const key = (event as KeyboardEvent).key; // const {key} = event; in ES6+

    if (this.tempKey === 'Control') {
      if (key === 'Enter') {
        this.saveItem();
      }
    }
    this.tempKey = key;

    if (!this.timerSub) {
      this.timerSub = timer(500).subscribe(() => {
        this.tempKey = null;
        this.timerSub = null;
      })
    }
  }

  ngAfterViewInit() {
    (this.punchItemTextArea.nativeElement as HTMLElement).focus();
  }

  saveItem() {
    this.loadingSpinner = true;

    const cItem = {
      id: this.checkItem.id,
      name: this.itemDescription,
      trelloId: this.checkItem.trelloId,
      tagTypes: this.checkItem.tagTypes
    } as TrelloCheckItem


    const obsArray: Observable<Any>[] = [];
    obsArray.push(this.trelloService.updateCheckItem(cItem))

    if (this.checkItem.tagTypes && this.checkItem.tagTypes.includes('Amount')) {
      const fTag = this.checkItem.tags.find(tag => tag.type.name === 'Amount')

      if (fTag) {
        fTag.amount = this.checkItem.changeOrderAmount;
        obsArray.push(this.trelloService.toggleTag(fTag))
      } else {
        cItem.amount = this.checkItem.changeOrderAmount
      }
    }

    forkJoin(obsArray).subscribe(item => {
      this.updateAction.emit(item[0] as TrelloCheckItem);

      if (item[1] as CheckItemHeadTag) {
        this.checkItem.changeOrderAmount = (item[1] as CheckItemHeadTag).amount;

        this.checkItem.tags.forEach(tag => {
          if (tag.type.name === 'Amount') {
            tag.amount = (item[1] as CheckItemHeadTag).amount
          }
        });
      }

      this.loadingSpinner = false;
    }, error => {
      this.loadingSpinner = false;
      this.openErrorSnackBar(error.message)
    })
  }


  hideInputItem() {
    this.closeAction.emit();
  }

  uploadFile(files: File[], filesForm?) {
    const fileArray = [];

    // tslint:disable-next-line: prefer-for-of
    for (let i = 0; i < files.length; i++) {
      fileArray.push(files[i])
    }

    this.trelloService.checkItemLoading$.next(this.checkItem.id);

    this.trelloService.uploadFile(fileArray, this.checkItem.id).subscribe(httpEvent => {
      if (httpEvent.type === HttpEventType.UploadProgress) {
        const progressEvent = httpEvent as HttpProgressEvent
        this.progressBar = Math.ceil(progressEvent.loaded / progressEvent.total * 100 / 3) * 3
      } else if (httpEvent.type === HttpEventType.Response) {
        const projectFiles = (httpEvent as HttpResponse<ProjectFile[]>).body;
        this.checkItem.files = this.checkItem.files.concat(projectFiles)
        this.trelloService.checkItemLoading$.next(-1)
        this.progressBar = 0
      }

      filesForm?.clear();
    }, error => {
      this.loadingSpinner = false
      this.openErrorSnackBar(error.message)
      this.progressBar = 0;
    })
  }

  createTask() {
    const tempData = {
      entityId: this.checkItem.id
      // text: this.checkItem.name
    } as Task

    const dialogRef = this.dialog.open(TaskEditDialogComponent, {
      data: {
        task: tempData,
        buttonLabel: 'Create',
        taskType: 'checkitem',
        entityId: this.checkItem.id,
        projectId: this.project.id,
        projectName: this.project.name
      },
      panelClass: 'task-edit-dialog',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'CheckItem') {
        // this.tasks.unshift(result)
        this.checkItem.tasksTotal++;
      }
    });

  }

  deleteItem() {
    this.deleteLoadingSpinner = true;
    this.deleteAction.emit();
  }

  openSnackBar(message: string, duration = 5000) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'overlap-snackbar',
      verticalPosition: 'top',
    });
  }

  openErrorSnackBar(message: string, duration = 5000) {
    if (this.activeSnackBar) {
      this.activeSnackBar.dismiss();
    }

    this.activeSnackBar = this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  tagChanged(tags: SelectItem[]) {
    this.checkItem.tagTypes = tags.map(tag => tag.value.name);
  }

  ngOnDestroy() {
    document.removeEventListener('keydown', this.ctrlEventListener);
  }

  onFilePaste(event: ClipboardEvent) {
    const items = (event.clipboardData).items;
    // tslint:disable-next-line: forin
    for (const index in items) {
      const item = items[index];
      if (item.kind === 'file') {
        const file = item.getAsFile();

        this.uploadFile([file])
      }
    }
  }

  onMentionSelect(user: User) {
    return '@' + user.username + ' ';
  }
}
